import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationReopeningReasonEntity } from '../../../domain/entities/investigation-reopening-reason.entity';

export interface GetInvestigationReopeningReasonsResult {
  reasons: InvestigationReopeningReasonEntity[];
}

@Injectable({ providedIn: 'root' })
export class GetInvestigationReopeningReasonsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _toast = inject(ToastProvider);

  public execute(): Observable<GetInvestigationReopeningReasonsResult> {
    return this._repository.getReopeningReasons().pipe(
      map((reasons) => ({ reasons })),
      catchError((error) => {
        this._toast.error('Failed to load reopening reasons', 'Please refresh and try again.');
        return throwError(() => error);
      }),
    );
  }
}
